'use strict';

/**
 *
 * @name: coverSeries
 *
 */

import DirectiveTemplate from './nn-cover-series.directive.html';
import './nn-cover-series.directive.scss';

function CoverSeriesDirective(
  apiPostService,
  transObject,
  $rootScope,
  $state,
  $stateParams,
  $location,
  apiSubscriptionsService,
  $compile,
  $timeout,
  angularticsService,
  seriesAnalytics,
  nnModalsService
) {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    transclude: true,
    scope: {
      content: '&',
      loaded: '=',
      mainSeriesPlayer: '='
    },
    template: DirectiveTemplate,
    link: function(scope, element) {

      var rootWatchers = {};

      scope.item = scope.content();
      scope.seriesAnalytics = seriesAnalytics;
      scope.item.title = scope.item.title || 'SERIES';
      scope.baiduTongji=()=>{
        window._hmt.push(['_trackEvent', '组件', 'click', `parentType=${scope.item.parentType},index=${scope.item.index},moduleId=${scope.item.id},parentSlug=${scope.item.parentSlug || ''}`]);
      }
      scope.onFollowClick = () => {
        if (!scope.item.series[0].isSubscribed && !scope.item.series[0].isOver) {
          scope.subscribe(scope.item.series[0].id)
          scope.seriesAnalytics.followSeries(scope.item.series[0])
        } else {
          scope.deleteSubscription(scope.item.series[0].id)
          scope.seriesAnalytics.unfollowSeries(scope.item.series[0])
        }
      }

      function terminate() {

        scope.$destroy();
        element.find('*').remove();
        element.remove();
      }

      if ($state.current.name !== 'main.seriesSingle') {

        if (!scope.item.jsonData.sources || !scope.item.jsonData.sources[0] || !scope.item.jsonData.sources[0].seriesId) {

          return terminate();
        }
      }

      if (!scope.item.series[0].translations.hasOwnProperty($rootScope.lang)) {

        transObject.translate(scope.item.series[0]);

        if (scope.item.series[0].posts && scope.item.series[0].posts.length) {

          scope.item.series[0].posts.forEach(function(post) {

            transObject.translate(post);
            transObject.getDuration(post);
            transObject.setBookmark(post);
            transObject.calendarDate(post);
            transObject.trueSlug(post, scope.item.series[0]);

            if (post.tags && post.tags.length) {

              post.tags.forEach(function(tag) {

                transObject.translate(tag);
              });
            }

            transObject.myAss(post);
          });
        }
      }

      scope.settings = {
        change: false,
        index: scope.item.index || 0,
        seriesPage: false,
        post: scope.item.post || null,
        seriesListing: false
      };

      if ($state.current.name === 'main.series') {
        scope.settings.seriesListing = true;
      }
      if ($state.current.name === 'main.seriesSingle') {
        scope.settings.seriesPage = true;
        scope.$watch('settings.change', function(newVal) {
          if (newVal === false || newVal === true) {

            scope.$parent.change = newVal;
            $rootScope.seriesWoot = newVal;
          }
        });
      }
      console.log(scope)
      if ((scope.item.post && $stateParams.postSlug) || $location.search().autoplay) {
        if (scope.item.post.statusCn !== 'published' || !scope.item.post.isPublished) {
          if (scope.settings.index < scope.item.series[0].length - 1) {
            console.log('播放'+scope.settings.index + 1+'个')
            scope.playIndex(scope.settings.index + 1);
          } else {
            console.log('播放第一个')
            scope.playIndex(0);
          }
        }

        scope.settings.change = true;

        if (scope.item.post) {

          if (scope.item.post.tags && scope.item.post.tags.length) {

            scope.item.post.tags.forEach(function(tag) {

              transObject.translate(tag);
            });
          }

          if (scope.item.post.contributors && scope.item.post.contributors.length) {

            scope.item.post.contributors.forEach(function(contributor) {

              transObject.trueSlug(contributor);
            });
          }

          transObject.myAss(scope.item.post);

          $rootScope.seo = {
            pageTitle: scope.item.post.translations[$rootScope.lang].seoTitle + ' | NOWNESS',
            metaDescription: scope.item.post.translations[$rootScope.lang].seoDescription,
            image: scope.item.post.socialUrl
          };
        }
      }

      scope.loaded = true;

      var play;

      function changeHtml() {

        element.off('click', play, changeHtml);
        scope.settings.change = true;

        scope.post = scope.item.post;

        if (scope.post.tags && scope.post.tags.length) {

          scope.post.tags.forEach(function(tag) {

            transObject.translate(tag);
          });
        }

        transObject.translate(scope.post);
        var compileContainer = element.find('.series-post-compile-container');
        compileContainer.empty();
        compileContainer.html('<p data-compile data-ng-if="postReady"></p>');
        $compile(compileContainer.contents())(scope);
        scope.postReady = true;
        $rootScope.$broadcast('postChange', scope.post);

        if (scope.item.series[0].posts[scope.settings.index + 1]) {

          apiPostService
            .getPostById(scope.item.series[0].posts[scope.settings.index + 1].id)
            .then(function(res) {

              transObject.translate(res.data);
              transObject.setBookmark(res.data);
              transObject.calendarDate(res.data);
              transObject.translate(res.data.category);

              if (res.data.tags && res.data.tags.length) {

                res.data.tags.forEach(function(tag) {

                  transObject.translate(tag);
                });
              }

              transObject.myAss(res.data);
              scope.nextPost = res.data;
            });
        }

        scope.$apply();
      }

      $timeout(function() {

        play = element.find('.wrap .series-page a');
        play.click(changeHtml);
      }, 300);

      scope.subscribe = function(seriesId) {

        if ($rootScope.profile) {

          apiSubscriptionsService
            .setSubscription(seriesId, 'series')
            .then(function() {

              scope.item.series[0].isSubscribed = true;
            });
        } else {

          $rootScope.seriesToFollow = scope.item.series[0];
          $rootScope.seriesToBeFollowed = true;
          rootWatchers.profile = $rootScope.$watch('profile', function(newVal) {

            if (newVal) {

              apiSubscriptionsService
                .setSubscription(seriesId, 'series')
                .then(function() {

                  scope.item.series[0].isSubscribed = true;
                });

              rootWatchers.profile();
            }
          });

          nnModalsService.showModal('login')
        }
      };

      scope.deleteSubscription = function(seriesId) {

        apiSubscriptionsService
          .deleteSubscription(seriesId, 'series')
          .then(function() {

            scope.item.series[0].isSubscribed = false;
          });
      };

      scope.nextPost = null;
      scope.postReady = false;
      if (scope.item.post && scope.item.post.translations[$rootScope.lang].content) {

        scope.post = angular.copy(scope.item.post);
        scope.postReady = true;
      }

      scope.$watch('settings.index', function(newVal) {

        if ($state.current.name === 'main.seriesSingle' && (newVal || newVal === 0)) {
          var extWrap = element.find('.ext-wrap');
          extWrap.stop().animate({
            scrollLeft: 240 * (scope.settings.index - 1)
          }, 300, 'swing');

          setTimeout(function() {

            var analyticsData = {
              pageTitle: scope.item.series[0].posts[newVal].translations[$rootScope.lang].title,
              pageID: 'NA',
              primaryCategory: 'series pages',
              subCategory1: 'series pages',
              subCategory2: 'series pages',
              pageType: 'content pages',
              attributes: {
                videoName: scope.item.series[0].posts[newVal].translations[$rootScope.lang].title,
                videoID: scope.item.series[0].posts[newVal].id
              }
            };

            angularticsService.pageTrack(analyticsData);
          }, 888);

        }

        if ($state.current.name === 'main.seriesSingle' && ($stateParams.postSlug || $location.search().autoplay)) {

          if (typeof newVal !== 'undefined') {

            if (scope.item.series[0].posts[newVal].statusCn !== 'published' || !scope.item.series[0].posts[newVal].isPublished) {
              console.log(newVal,scope.item.series[0])
              if(newVal !== 0){
                scope.playIndex(newVal);
              }
              // if (newVal < scope.item.series[0].length - 1) {
              //   scope.playIndex(newVal + 1);
              // }
               else {

                scope.playIndex(0);
              }
            }

            if (scope.post && scope.post.id === scope.item.series[0].posts[newVal].id && scope.item.series[0].posts[newVal + 1]) {

              apiPostService
                .getPostById(scope.item.series[0].posts[scope.settings.index + 1].id)
                .then(function(res) {

                  transObject.translate(res.data);
                  transObject.setBookmark(res.data);
                  transObject.calendarDate(res.data);
                  transObject.translate(res.data.category);

                  if (res.data.tags && res.data.tags.length) {

                    res.data.tags.forEach(function(tag) {

                      transObject.translate(tag);
                    });
                  }

                  transObject.myAss(res.data);
                  scope.nextPost = res.data;
                });
            } else if (scope.nextPost && scope.nextPost.id === scope.item.series[0].posts[newVal].id) {

              scope.post = scope.nextPost;
              $rootScope.$broadcast('postChange', scope.post);
              var compileContainer = element.find('.series-post-compile-container');
              compileContainer.empty();
              compileContainer.html('<p data-compile data-ng-if="postReady"></p>');
              $compile(compileContainer.contents())(scope);
              scope.postReady = true;
              $location.path('/series/' + scope.item.series[0].translations[$rootScope.lang].slug + '/' + scope.post.translations[$rootScope.lang].slug);

              if (scope.item.series[0].posts[scope.settings.index + 1]) {

                apiPostService
                  .getPostById(scope.item.series[0].posts[scope.settings.index + 1].id)
                  .then(function(res) {

                    transObject.translate(res.data);
                    transObject.setBookmark(res.data);
                    transObject.calendarDate(res.data);
                    transObject.translate(res.data.category);

                    if (res.data.tags && res.data.tags.length) {

                      res.data.tags.forEach(function(tag) {

                        transObject.translate(tag);
                      });
                    }

                    transObject.myAss(res.data);
                    scope.nextPost = res.data;
                  });
              } else {

                scope.nextPost = null;
              }
            } else {

              apiPostService
                .getPostById(scope.item.series[0].posts[scope.settings.index].id)
                .then(function(res) {

                  transObject.translate(res.data);
                  transObject.setBookmark(res.data);
                  transObject.calendarDate(res.data);
                  transObject.translate(res.data.category);
                  scope.post = res.data;
                  scope.settings.post = res.data;

                  if ($location.search().autoplay) {

                    scope.settings.change = true;
                  }

                  if (res.data.tags && res.data.tags.length) {

                    res.data.tags.forEach(function(tag) {

                      transObject.translate(tag);
                    });
                  }

                  transObject.myAss(res.data);
                  var compileContainer = element.find('.series-post-compile-container');
                  compileContainer.empty();
                  compileContainer.html('<p data-compile data-ng-if="postReady"></p>');
                  $compile(compileContainer.contents())(scope);
                  scope.postReady = true;
                  $location.path('/series/' + scope.item.series[0].translations[$rootScope.lang].slug + '/' + scope.post.translations[$rootScope.lang].slug);
                  $rootScope.$broadcast('postChange', scope.post);
                });

              if (scope.item.series[0].posts[scope.settings.index + 1]) {

                apiPostService
                  .getPostById(scope.item.series[0].posts[scope.settings.index + 1].id)
                  .then(function(res) {

                    transObject.translate(res.data);
                    transObject.setBookmark(res.data);
                    transObject.calendarDate(res.data);
                    transObject.translate(res.data.category);

                    if (res.data.tags && res.data.tags.length) {

                      res.data.tags.forEach(function(tag) {

                        transObject.translate(tag);
                      });
                    }

                    transObject.myAss(res.data);
                    scope.nextPost = res.data;
                  });
              }
            }
          }
        }
      });

      scope.playIndex = function(index) {

        if (index !== scope.settings.index) {
          var data = {
            dontGoNext: true,
          };
          $rootScope.$broadcast('filmFinished', data);
          scope.settings.index = index;
        }
      };

      var watchSeries = $rootScope.$on('$stateChangeSuccess', function() {

        watchSeries();
        scope.$destroy();
      });

      scope.$on('$destroy', function() {

        $rootScope.$broadcast('destroyPlaya');

        Object.keys(rootWatchers)
          .forEach(function(killWatcherKey) {

            rootWatchers[killWatcherKey]();
          });

        element.find('*').remove();
      });
    }
  };
}

export default CoverSeriesDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/series/nn-cover-series/nn-cover-series.directive.js